import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import {
  getWorkflow,
  clearRunningWorkflow,
  runWorkflow,
} from "actions/workflows";
import Input from "components/Elements/Input";

const TestWorkflowModal = NiceModal.create(({ workflow_id }) => {
  const dispatch = useDispatch();
  const { workflow, runningWorkflow, workflowResults } = useSelector(
    (state) => state.workflows
  );
  const [input, setInput] = useState("");
  const modal = useModal();

  useEffect(() => {
    dispatch(getWorkflow(workflow_id));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log("LOADED workflow: ", workflow);
  }, [workflow]);

  const hide = (e) => {
    e.stopPropagation();
    dispatch(clearRunningWorkflow());
    modal.remove();
  };

  const handleChange = ({ target }) => {
    setInput(target.value);
  };

  return (
    <>
      <div className="w-6/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative h-auto w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">
                {workflow ? `Testing: ${workflow.name}` : "Loading Workflow..."}
              </h3>
            </div>
            <div style={{ paddingLeft: "20px" }}>
              {workflow &&
                workflow.use_llm &&
                `${workflow.llm} - ${workflow.max_tokens} max tokens - ${workflow.temperature} temperature`}
            </div>
            <div className="relative p-6 flex-auto ">
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <Input
                  type="textarea"
                  label="input"
                  placeholder="Input"
                  name="input"
                  value={input}
                  style={{ height: "200px" }}
                  onChange={handleChange}
                />
              </div>
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <Input
                  type="textarea"
                  label="Output"
                  placeholder="Output"
                  name="output"
                  value={workflowResults || ""}
                  disabled={true}
                  style={{ height: "200px" }}
                />
              </div>
            </div>

            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              {!runningWorkflow ? (
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              ) : null}
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={() => dispatch(runWorkflow(workflow.public_id, input))}
                disabled={runningWorkflow}
              >
                Run
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

export default TestWorkflowModal;
